import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { RoutesService } from '../../services/routes.service';
import { Pagination } from '../../models/pagination';

import { Store } from '@ngrx/store';
import { AppState } from '../../../store/index';
import { Observable } from 'rxjs';
import { ConsoleUtils } from '@app/shared/helpers/console-utils';



@Component({
    selector: 'app-paginator',
    templateUrl: './paginator.component.html',
})
export class PaginatorComponent implements OnInit {

    @Input() itemsShow: number;
    @Input() forceSection: string;

    @Output() currentChange = new EventEmitter();

    currentSection$: Observable<string>;
    currentSection: string;

    paginator$: Observable<Pagination>;
    paginator: Pagination;

    itemPaginators: Array<any>;

    constructor(
        private store: Store<AppState>
    ) {
        this.paginator = null;
    }

    initCurrentSection() {
        this.currentSection$ = this.store.select(state => state.layout.currentSection);
        this.currentSection$.subscribe(res => {
            this.currentSection = res;

            this.setCurrentPaginatorObserve();
        });
    }

    setCurrentPaginatorObserve() {

        if (this.forceSection) {
            switch (this.forceSection) {
                default: this.paginator$ = null;
                    break;
            }

        } else {
            ConsoleUtils.log('currentSection', this.currentSection);
            switch (this.currentSection) {

                case 'books': this.paginator$ = this.store.select(state => state.books.paginator);
                    break;

                case 'students': this.paginator$ = this.store.select(state => state.students.paginator);
                    break;

                case 'groups': this.paginator$ = this.store.select(state => state.groups.paginator);
                    break;

                case 'pages': this.paginator$ = this.store.select(state => state.pages.paginator);
                    break;                

                case 'faqs': this.paginator$ = this.store.select(state => state.faqs.paginator);
                    break;

                case 'faqs-categories': this.paginator$ = this.store.select(state => state.faqsCategories.paginator);
                    break;

                default: this.paginator$ = null;
                    break;
            }
        }

        if (this.paginator$) {
            this.paginator$.subscribe(res => {
                this.paginator = res;

                this.calculatePagination();
            });
        }
    }

    ngOnInit() {
        this.initCurrentSection();
    }

    calculatePagination() {
        if (!this.paginator) {
            return;
        }

        const current: number = this.paginator.currentPage || 1;
        const last: number = this.paginator.lastPage;
        const delta: number = this.itemsShow || 2;
        const left: number = current - delta;
        const right: number = current + delta + 1;
        const range: Array<any> = [];

        let i: number;
        let l: number;

        this.itemPaginators = [];
        for (i = 1; i <= last; i++) {
            if (i === 1 || i === last || i >= left && i < right) {
                range.push(i);
            }
        }

        for (i of range) {
            if (l) {
                if (i - l === 2) {
                    this.itemPaginators.push(l + 1);
                } else if (i - l !== 1) {
                    this.itemPaginators.push('...');
                }
            }
            this.itemPaginators.push(i);
            l = i;
        }
    }

    disabledClick(ev) {
        ev.preventDefault();
    }


    clickItemPage(ev, page) {
        ev.preventDefault();

        if (isNaN(page)) {
            return;
        }

        this.paginator.currentPage = page;
        this.updateCurrent();
    }

    clickPrev(ev) {
        ev.preventDefault();

        this.paginator.currentPage--;
        this.updateCurrent();
    }

    clickNext(ev) {
        ev.preventDefault();

        this.paginator.currentPage++;
        this.updateCurrent();
    }

    updateCurrent() {
        this.calculatePagination();
        this.currentChange.emit({ page: this.paginator.currentPage });
    }

}
